interface DapBffConfig {
  url: string;
  urlV2: string;
}

type Env = 'dev' | 'stage' | 'prod' | 'local';

interface EnvConfigs {
  dev: DapBffConfig;
  stage: DapBffConfig;
  prod: DapBffConfig;
}

const envConfigs: EnvConfigs = {
  dev: {
    url: 'https://dap-bff.datahub-dev.mestergruppen.cloud',
    urlV2: 'https://dev.mestergruppen-dap-api.george.no',
  },
  stage: {
    url: 'https://dap-bff.datahub-stage.mestergruppen.cloud',
    urlV2: 'https://stage.mestergruppen-dap-api.george.no',
  },
  prod: {
    url: 'https://dap-bff.datahub-prod.mestergruppen.cloud',
    urlV2: 'https://mestergruppen-dap-api.vercel.app',
  },
};
const env = (process.env['NX_PUBLIC_REACT_APP_ENV'] || 'local') as Env;

export const dapBffConfig = env === 'local' ? envConfigs.dev : envConfigs[env];
